import Vue from 'vue';
import customRules from "@/validation/rules";
import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize,
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import { required, email, min, max,confirmed } from "vee-validate/dist/rules"; 


extend('required', required);
extend('email', email); 
extend('min', min); 
extend('max', max)
extend('confirmed', confirmed)

Object.keys(customRules).forEach(rule => {
    extend(rule, customRules[rule]);
});

localize("en", en);


Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
